import { BodyText, withStyles } from 'vopay';
import { PermissionItem } from '../types';
import PermissionGroup from '../PermissionGroup/PermissionGroup';
import { usePermissionsContext } from '../PermissionsContext';
import styles from './Permission.module.scss';

const cn = withStyles(styles);

type PermissionProps = {
  item: PermissionItem;
};

export default function Permission({ item }: PermissionProps) {
  const { editor, readOnly } = usePermissionsContext();
  const fieldConfig = editor.getFieldConfig(item.code);

  if (!fieldConfig) return null;

  return editor.renderFormElements({
    config: [fieldConfig],
    override: (fieldData) => {
      const label = (
        <BodyText className={cn('permissionLabelText')} weight="md">
          {item.label}
        </BodyText>
      );

      const control = <div className={cn('permissionFieldWrapper')}>{fieldData.template}</div>;

      return (
        <PermissionGroup.Row>
          {item.type === 'boolean' ? (
            <label className={cn('permissionRowLabel', readOnly && 'readOnly')}>
              {label}
              {control}
            </label>
          ) : (
            <>
              {label}
              {control}
            </>
          )}
        </PermissionGroup.Row>
      );
    },
  });
}
